import { ColumnTable, Icon } from '@octano/global-ui';
import { UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { EvaluationScalesResponse } from '../types';

interface useColumnActions {
  onClickEdit: (row: any) => void;
  onClickView: (row: any) => void;
  onClickRemove: (row: any) => void;
}

export default function useColumns(
  props: useColumnActions,
): ColumnTable<EvaluationScalesResponse>[] {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_SURVEY_EVALUATION_SCALES,
  );
  const { onClickEdit, onClickRemove, onClickView } = props;

  return [
    {
      columnName: 'title',
      headerText: t('scaleList.headers.title'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'optionsAmount',
      headerText: t('scaleList.headers.optionsAmount'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'minimumScore',
      headerText: t('scaleList.headers.minimumScore'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'maximumScore',
      headerText: t('scaleList.headers.maximumScore'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'actions',
      headerText: t('scaleList.headers.actions'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        const targetId = `tooltip-edit-${row.id}`;
        const hasSurvey = row.hasSurvey;

        return (
          <div className="d-flex justify-content-end">
            {hasSurvey && (
              <button
                className="btn"
                onClick={() => onClickView(row)}
                disabled={!hasSurvey}
              >
                <Icon name="eye" color={'primary'} />
              </button>
            )}
            <button
              className="btn"
              onClick={() => onClickEdit(row)}
              disabled={hasSurvey}
              id={targetId}
            >
              {hasSurvey && (
                <UncontrolledTooltip placement="right" target={targetId}>
                  {t('scaleList.hasSurveyTooltip.edit')}
                </UncontrolledTooltip>
              )}
              <Icon color={hasSurvey ? 'disabled' : 'primary'} name="edit" />
            </button>

            <button
              className="btn"
              onClick={() => onClickRemove(row)}
              disabled={hasSurvey}
              id={targetId}
            >
              {hasSurvey && (
                <UncontrolledTooltip placement="right" target={targetId}>
                  {t('scaleList.hasSurveyTooltip.delete')}
                </UncontrolledTooltip>
              )}
              <Icon name="trash" color={hasSurvey ? 'disabled' : 'primary'} />
            </button>
          </div>
        );
      },
    },
  ];
}
